module.exports = __webpack_public_path__ + "media/images/amenities_icons/walk-public-9e30058239ad1ec904c590e1b89833a7.svg";